<div class="card shadow-lg">
  <div class="">
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link active" role="tab" data-bs-toggle="tab" href="#tabGroup1"
          ><strong>Group {{ findGroupName(1) }}</strong></a
        >
      </li>
      <li class="nav-item">
        <a class="nav-link" role="tab" data-bs-toggle="tab" href="#tabGroup2"
          ><strong>Group {{ findGroupName(2) }}</strong></a
        >
      </li>
    </ul>

    <div class="tab-content">
      <div class="tab-pane active" role="tabpanel" id="tabGroup1">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Company</th>
              <th>Last Inserted Date</th>
              <th>Latest Account Date</th>
            </tr>
          </thead>
          @for (usage of usageList; track usage) {
            <tbody>
              @if (usage.Group == 1) {
                <tr>
                  <td [style.background-color]="getWarningStatus(usage.LatestDate)">{{ usage.CompanyCode }}</td>
                  <td [style.background-color]="getWarningStatus(usage.LatestDate)">
                    {{ usage.LastInsertedDate | date: "dd-MM-yyyy" }}
                    @if (usage.LatestDate == undefined) {
                      <span class="badge text-bg-danger">>= 1 MONTH NO ACCOUNT</span>
                    }
                  </td>
                  <td [style.background-color]="getWarningStatus(usage.LatestDate)">{{ usage.LatestDate | date: "dd-MM-yyyy" }}</td>
                </tr>
              }
            </tbody>
          }
        </table>
      </div>
      <div class="tab-pane" role="tabpanel" id="tabGroup2">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Company</th>
              <th>Last Inserted Date</th>
              <th>Latest Account Date</th>
            </tr>
          </thead>
          @for (usage of usageList; track usage) {
            <tbody>
              @if (usage.Group == 2) {
                <tr>
                  <td [style.background-color]="getWarningStatus(usage.LatestDate)">{{ usage.CompanyCode }}</td>
                  <td [style.background-color]="getWarningStatus(usage.LatestDate)">
                    {{ usage.LastInsertedDate | date: "dd-MM-yyyy" }}
                    @if (usage.LatestDate == undefined) {
                      <span class="badge text-bg-danger">>= 1 MONTH NO ACCOUNT</span>
                    }
                  </td>
                  <td [style.background-color]="getWarningStatus(usage.LatestDate)">{{ usage.LatestDate | date: "dd-MM-yyyy" }}</td>
                </tr>
              }
            </tbody>
          }
        </table>
      </div>
    </div>
  </div>
</div>
